// Globals
import { useTranslation } from 'react-i18next';

// Components
import { EditableInput } from '@/components';
import { StyledWrapper } from './GeneralSettingsFormStyles';

// Helpers
import { GeneralSettingsFields, TGeneralSettingsValues } from '../../helpers';
import { useGeneralSettingsFormRules } from '../../hooks';

type TGeneralSettingsFormProps = {
  isLoading: boolean;
  onSubmit: (values: Partial<TGeneralSettingsValues>) => void;
  initialValues?: Partial<TGeneralSettingsValues>;
};

const GeneralSettingsForm = ({ isLoading, onSubmit, initialValues }: TGeneralSettingsFormProps) => {
  const { t } = useTranslation(['settings']);
  const rules = useGeneralSettingsFormRules();
  return (
    <StyledWrapper>
      <EditableInput
        onChange={onSubmit}
        label={t('general_organization')}
        name={GeneralSettingsFields.ORGANIZATION}
        rules={rules[GeneralSettingsFields.ORGANIZATION]}
        initialValues={initialValues}
        isLoading={isLoading}
      />
      <EditableInput
        onChange={onSubmit}
        label={t('general_support_phone_number')}
        name={GeneralSettingsFields.SUPPORT_PHONE_NUMBER}
        rules={rules[GeneralSettingsFields.SUPPORT_PHONE_NUMBER]}
        initialValues={initialValues}
        isLoading={isLoading}
      />
      <EditableInput
        onChange={onSubmit}
        label={t('general_support_email')}
        name={GeneralSettingsFields.SUPPORT_EMAIL}
        rules={rules[GeneralSettingsFields.SUPPORT_EMAIL]}
        initialValues={initialValues}
        isLoading={isLoading}
      />
    </StyledWrapper>
  );
};

export default GeneralSettingsForm;
